import { IDateInputFieldsValue } from 'src/components/DateInputFields';
import { PwrIdentificationItemType } from 'src/utils/Transfers';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('@login');

/**
 * ログイン画面のお知らせデータ
 */
export interface INoticeMessage {
	/** 連絡先 */
	readonly contact: string;
	/** 開始日時 */
	readonly startDate: string;
	/** タイトル ※改行による複数行対応 */
	readonly titleList: string[];
	/** メッセージ */
	readonly message: string[];
}

/**
 * ログイン後のメッセージ表示フラグ
 */
export interface ILoggedInMessage {
	/** ダイアログ表示フラグ */
	readonly displayDesktopMessageDialog: boolean;
	/** 前回ログイン日時表示フラグ（モバイルは非表示） */
	readonly displayLastLoginInfo: boolean;
	/** 前回ログイン日時のIPアドレス表示フラグ */
	readonly displayLastLoginIPAddress: boolean;
	/** パスワード変更事前警告フラグ */
	readonly displaySecuritySamePwdWarningMessage: boolean;
	/** 研修として登録されていないC3コンテンツIDに対応するライセンスがある判定警告フラグ */
	readonly displayContentsLicenseInfoMessage: boolean;
	/** 前回ログイン失敗日時 */
	readonly lastLoginFailedDateTime?: string;
	/** 前回ログイン失敗IPアドレス */
	readonly lastLoginFailedIPAddress?: string;
	/** 前回ログイン成功日時 */
	readonly lastLoginSuccessDateTime?: string;
	/** 前回ログイン成功IPアドレス */
	readonly lastLoginSuccessIPAddress?: string;
	/** パスワード変更期限までの日数 */
	readonly remainChangePwdExpireDateNum?: number;
	/** 登録失敗したコンテンツのID */
	readonly lastCreatedFaildContentIds?: string;
}

/** プログレス表示アクションクリエータ */
export const showLoginProgress = actionCreator<{
	isShowProgress: boolean;
}>('SHOW_LOGIN_PROGRESS');

interface ISetLoginManagerNoticePayload {
	/** お知らせカルーセルのスライド間隔 */
	readonly carouselChangeInterval: number;
	/** お知らせデータリスト */
	readonly messages: INoticeMessage[];
	/** パスワードリマインダ系プロパティ */
	readonly pwr: {
		/** 検証対象項目リスト */
		readonly identificationItems: PwrIdentificationItemType[];
		/** 「パスワードを忘れた場合はこちら」リンク表示制御 */
		readonly passwordLinkEnabled: boolean;
		/** 「IDを忘れた場合はこちら」リンク表示制御 */
		readonly loginIdLinkEnabled: boolean;
	};
}

/** お知らせデータ設定アクションクリエータ */
export const setLoginManagerNotice = actionCreator<
	ISetLoginManagerNoticePayload
>('SET_LOGIN_MANAGER_NOTICE');

/** パスワード変更のloginId取得アクションクリエータ */
export const setLoginIDPwrChangePassword = actionCreator<{
	loginID: string;
}>('SET_LOGINID_PWRCHANGEPASSWORD');

/** ログイン後メッセージ設定アクションクリエータ */
export const setLoggedInMessage = actionCreator<{
	displayDesktopMessageDialog: boolean;
	displayLastLoginInfo: boolean;
	displayLastLoginIPAddress: boolean;
	displaySecuritySamePwdWarningMessage: boolean;
	displayContentsLicenseInfoMessage: boolean;
	lastLoginFailedDateTime: string;
	lastLoginFailedIPAddress: string;
	lastLoginSuccessDateTime: string;
	lastLoginSuccessIPAddress: string;
	remainChangePwdExpireDateNum: number;
	lastCreatedFaildContentIds?: string;
}>('SET_LOGGED_IN_MESSAGE');

/** ログイン後メッセージクリアアクションクリエータ */
export const clearLoggedInMessage = actionCreator<{}>(
	'CLEAR_LOGGED_IN_MESSAGE'
);

/** パスワード変更成功フラグ設定アクションクリエータ */
export const setPasswordChangeSuccess = actionCreator<{
	passwordChangeSuccess: boolean;
}>('SET_PASSWORD_CHANGE_SUCCESS');

/**
 * FIXME
 */
export const setSendmailEndDialog = actionCreator<{ open: boolean }>(
	'SET_SENDMAIL_END_DIALOG'
);

export const closeSendmailEndDialogById = actionCreator<{
	idreminderOpen: boolean;
	sendmailEndOpen: boolean;
}>('SET_SENDMAIL_END_DIALOG_ID');

export const closeSendmailEndDialogByPw = actionCreator<{
	pwreminderOpen: boolean;
	sendmailEndOpen: boolean;
}>('SET_SENDMAIL_END_DIALOG_PW');

/** パスワード再発行画面openフラグ設定アクションクリエータ */
export const setPwreminderOpen = actionCreator<{
	pwreminderOpen: boolean;
}>('SET_PWREMINDER_OPEN');

/** ログインID通知およびパスワード再発行画面openフラグ設定アクションクリエータ */
export const setIdreminderOpen = actionCreator<{
	idreminderOpen: boolean;
}>('SET_IDREMINDER_OPEN');

/**
 * パスワードリマインダ検証項目を選択
 */
export interface IPwReminderSelectIdentifier {
	/**
	 * 検証項目
	 */
	selected: PwrIdentificationItemType;
}

/**
 * パスワードリマインダ検証項目を選択
 */
export const selectPwrIdentifier = actionCreator<IPwReminderSelectIdentifier>(
	'SELECT_PWR_IDENTIFIER'
);

/**
 * 検証項目の入力値
 */
export type IdentifierInputValue =
	| {
			type: 'PWREMIND_SHOW_BIRTHDAY' | 'IDREMIND_SHOW_BIRTHDAY';
			entity: IDateInputFieldsValue;
	  }
	| {
			type: Exclude<
				PwrIdentificationItemType,
				'PWREMIND_SHOW_BIRTHDAY' | 'IDREMIND_SHOW_BIRTHDAY'
			>;
			entity: string;
	  }
	| {
			type?: never;
	  };

/**
 * パスワードリマインダ検証項目を入力
 */
export const changeIdentifierInputValue = actionCreator<IdentifierInputValue>(
	'CHANGE_IDENTIFIER_INPUT_VALUE'
);

export const setPwrIdentifierKey = actionCreator<{ identifierKey: string }>(
	'SET_PWR_IDENTIFIER_KEY'
);
/** ロゴ設定アクションクリエータ */
export const setLoginLogo = actionCreator<{
	showCMOption: boolean;
	showLangOption: boolean;
}>('SET_LOGIN_LOGO');



// WEBPACK FOOTER //
// ./src/actions/login.ts